import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import OptimizationPipelineLogTableService from '../service/OptimizationPipelineLogTableService';
import ShowChartButton from '../component/ShowChartButton';

const config = {
	key: 'optimizationPipelineLogTable',
	topic: 'optimizationPipelineLog',
	service: OptimizationPipelineLogTableService,
	editFormState: item => `/optimization-pipeline-log/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['exportData', 'modify', 'delete'],
	rowButtonList: [{ key: 'showChart', component: ShowChartButton }],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}optimizationPipelineLogTableControl/exportToXlsx?id=${item.id}`
	},
	columns: [
		{
			key: 'name'
		},
		{
			key: 'table_name'
		},
		{
			key: 'description'
		}
	]
};

function OptimizationPipelineLogTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('optimizationPipelineLogTable', reducer('optimizationPipelineLogTable'))(OptimizationPipelineLogTable);
